import { render } from "./transfer-course-dialog.vue?vue&type=template&id=44f0660c"
import script from "./transfer-course-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-course-dialog.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./transfer-course-dialog.vue?vue&type=style&index=0&id=44f0660c&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./transfer-course-dialog.vue?vue&type=style&index=0&id=44f0660c&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("44f0660c")
  })
}

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/transfer-course-dialog/transfer-course-dialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44f0660c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44f0660c', __exports__)) {
    api.reload('44f0660c', __exports__)
  }
  
  module.hot.accept("./transfer-course-dialog.vue?vue&type=template&id=44f0660c", () => {
    api.rerender('44f0660c', render)
  })

}


export default __exports__